/** Anmeldung: Einladung annehmen (PIN festlegen) oder mit Kürzel + PIN anmelden. */
import { api } from '../api.js';
import { $, errorText, esc, formValues } from '../ui.js';

export function renderLogin(el: HTMLElement, onDone: () => void): void {
  el.innerHTML = `
  <section class="auth">
    <h1 class="auth-title">Zeiterfassung</h1>
    <p class="muted">HubTime GmbH</p>
    <form id="login" class="card stack">
      <label>Kürzel<input name="short" autocomplete="username" autocapitalize="characters" required></label>
      <label>PIN<input name="pin" type="password" inputmode="numeric" autocomplete="current-password" required></label>
      <p class="form-error" id="err" role="alert"></p>
      <button class="btn primary big">Anmelden</button>
    </form>
    <p class="muted small">Zum ersten Mal hier? Öffnen Sie den Einladungslink, den Sie von der Verwaltung bekommen haben,
    oder geben Sie den Code ein:</p>
    <form id="code" class="row">
      <input name="code" placeholder="Einladungscode" autocapitalize="characters" required>
      <button class="btn">Weiter</button>
    </form>
  </section>`;
  const form = $('#login', el) as HTMLFormElement;
  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    const v = formValues(form);
    try {
      await api('/auth/login', { method: 'POST', body: { short: v.short, pin: v.pin } });
      onDone();
    } catch (err) {
      $('#err', el).textContent = errorText(err);
    }
  });
  ($('#code', el) as HTMLFormElement).addEventListener('submit', (ev) => {
    ev.preventDefault();
    const code = formValues(ev.target as HTMLFormElement).code.trim().toUpperCase();
    location.hash = `#/einladung/${encodeURIComponent(code)}`;
  });
}

export async function renderInvite(el: HTMLElement, code: string, onDone: () => void): Promise<void> {
  let info: { name: string; short: string; role: string };
  try {
    info = await api(`/auth/invite/${encodeURIComponent(code)}`);
  } catch (err) {
    el.innerHTML = `<section class="auth"><h1 class="auth-title">Einladung</h1>
      <p class="form-error">${esc(errorText(err))}</p>
      <p>Bitte bei der Verwaltung einen neuen Link anfordern.</p><a class="btn" href="#/login">Zur Anmeldung</a></section>`;
    return;
  }
  const admin = info.role === 'admin';
  el.innerHTML = `
  <section class="auth">
    <h1 class="auth-title">Willkommen, ${esc(info.name.split(' ')[0])}</h1>
    <p>Ihr Kürzel ist <strong>${esc(info.short)}</strong>. Wählen Sie jetzt ${admin ? 'ein Passwort (mind. 8 Zeichen)' : 'eine PIN mit 4 bis 6 Ziffern'}.
    Dieses Handy bleibt danach 180 Tage angemeldet.</p>
    <form id="act" class="card stack">
      <label>${admin ? 'Passwort' : 'PIN'}<input name="pin" type="password" ${admin ? '' : 'inputmode="numeric" pattern="[0-9]{4,6}"'} autocomplete="new-password" required></label>
      <label>Wiederholen<input name="pin2" type="password" ${admin ? '' : 'inputmode="numeric"'} autocomplete="new-password" required></label>
      <p class="form-error" id="err" role="alert"></p>
      <button class="btn primary big">Speichern und loslegen</button>
    </form>
  </section>`;
  const form = $('#act', el) as HTMLFormElement;
  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    const v = formValues(form);
    if (v.pin !== v.pin2) {
      $('#err', el).textContent = 'Die Eingaben stimmen nicht überein.';
      return;
    }
    try {
      await api('/auth/activate', { method: 'POST', body: { code, pin: v.pin } });
      location.hash = '#/';
      onDone();
    } catch (err) {
      $('#err', el).textContent = errorText(err);
    }
  });
}
